// @ts-nocheck 9a197cd0
import localModeActionTypes from './localModeActionTypes';
const { SET_IS_RECONNECTING } = localModeActionTypes;
const setIsReconnecting = (isReconnecting) => ({
  type: SET_IS_RECONNECTING,
  isReconnecting,
});

export default setIsReconnecting;
